import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import 'isomorphic-fetch';
import styled from 'styled-components';

import ThemeProvider from '@g4/boneyard/lib/ThemeProvider';
import { Button } from '../Boneyard';
import { withBreakpoints } from '@g4/boneyard/lib/Media';
import VerticalSpacing from '@g4/boneyard/lib/VerticalSpacing';
import Box from '@g4/boneyard/lib/Box';

import ErrorModal from '../ErrorModalSelector/modals/ErrorModal';

import theme from '../../theme';
import { extractTokens } from '../WithApollo/authUtils';

const { publicRuntimeConfig: { mount } = {} } = getConfig() || {};

const RELATIVE_LOG_PATH = '/logz';

const Paragraph = styled.p`
  max-width: 500px;
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);

    this.state = {
      hasError: false,
    };
  }

  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'test') {
      console.error(error);
    } else {
      // Don't attempt to post a log when in test since the service won't exist
      const uri = mount
        ? `${window.location.origin}${mount}${RELATIVE_LOG_PATH}`
        : `${window.location.origin}${RELATIVE_LOG_PATH}`;
      const tokens = extractTokens();
      delete tokens.authToken;
      fetch(uri, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({ error: error.stack, data: tokens }),
      });
    }
    this.setState({ hasError: true });
  }

  onClose() {
    window.location = window.location.origin;
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <ThemeProvider theme={theme}>
          <ErrorModal title="Something really odd just happened&hellip;">
            <Box d="flex" alignItems="center" direction="column">
              <Paragraph>
                An unexpected error occurred while we were processing your
                request. Please click below and try again.
              </Paragraph>
              <VerticalSpacing size={4} />
              <Button onClick={this.onClose}>Continue</Button>
            </Box>
          </ErrorModal>
        </ThemeProvider>
      );
    }

    return children;
  }
}

export default withBreakpoints(ErrorBoundary);
